import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private message: NzMessageService,
    private ngxLoader: NgxUiLoaderService,
  ) {}

  getNews(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/news?page=${page}&limit=${pageSize}`,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve news');
            reject(error);
          },
        );
    });
  }
  //
  getNewsById(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/news/${id}`,{withCredentials: true}).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve news');
          reject(error);
        },
      );
    });
  }

  getNewsBySearch(name: string, page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/news?where[title][contains]=${name}&page=${page}&limit=${pageSize}`,{withCredentials: true},
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve News');
            reject(error);
          },
        );
    });
  }
}
